import { Router } from "@lib/router";

const LV_LOCALE = "lv";

/**
 * The extended cookie modal (Social media / Other categories and the footer links)
 * is only shown for the LV market environment.
 */
export const isLvEnvironment = (): boolean => Router.defaultLocale === LV_LOCALE;

